import {gql} from '@apollo/client'

export const GET_ALL_POLICIES_TYPES = gql`
  query allPoliciesType(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: Float
    $typePolicy: String
  ) {
    allPoliciesType(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
      typePolicy: $typePolicy
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          typePolicy
        }
      }
    }
  }
`

export const GET_ALL_POLICIES_STATUSES = gql`
  query allPolicyStatuses(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $code: String
    $code_Icontains: String
    $code_Istartswith: String
    $title: String
    $title_Icontains: String
    $title_Istartswith: String
  ) {
    allPolicyStatuses(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      code: $code
      code_Icontains: $code_Icontains
      code_Istartswith: $code_Istartswith
      title: $title
      title_Icontains: $title_Icontains
      title_Istartswith: $title_Istartswith
    ) {
      edges {
        node {
          id
          enabledForAgents
          code
          category
          title
          color
          systemReserved
        }
      }
    }
  }
`

export const GET_POLICY_STATUS_BY_CODE = gql`
  query policyStatusByCode($code: String!) {
    policyStatusByCode(code: $code) {
      id
      enabledForAgents
      code
      category
      title
      color
      systemReserved
    }
  }
`

export const RECENT_POLICY_YEARS = gql`
  query {
    recentPolicyYears
  }
`
